// Categories
import popular from './popular.png';
import topRated from './top rated.png';
import upcoming from './upcoming.png';

export default {
  popular, // <=> popular: popular
  'top rated': topRated,
  upcoming,
};
